// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { flowMainnet as _flowMainnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the flowMainnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 747
 * Chain Name: FlowEVM Mainnet
 * Default Block Explorer: https://flowdiver.io
 * Default RPC URL: https://mainnet.evm.nodes.onflow.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { flowMainnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: flowMainnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const flowMainnet = createCommon({
	..._flowMainnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
